import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { isPlatformServer } from '@angular/common';
import { ActivatedRouteSnapshot, CanActivate } from '@angular/router';

import { Store } from '@ngrx/store';

import { snapshot } from '@fcom/rx';
import { isPresent } from '@fcom/core/utils';
import { PaymentStatus } from '@fcom/common-booking/interfaces';
import { paymentStatus } from '@fcom/common-booking/store/selectors';
import { BOOKING_STEPS } from '@fcom/common/config/booking-config';
import { BookingAppState } from '@fcom/common/interfaces/booking/booking-state.interface';

import { BookingService } from '../../../services';
import { isAncillariesSkipped, isCartInErrorStateOrDoWeHaveTravelers } from '../../../utils';
import { cartData, cartStatus } from '../../../store/selectors';

@Injectable()
export class PurchaseReviewGuard implements CanActivate {
  constructor(
    private store$: Store<BookingAppState>,
    private bookingService: BookingService,
    @Inject(PLATFORM_ID) private platform: object
  ) {}

  canActivate(route: ActivatedRouteSnapshot): boolean {
    if (isPlatformServer(this.platform)) {
      return true;
    }

    if (this.isReviewAndPayFlow(route)) {
      return true;
    }

    const currentCartData = snapshot(this.store$.pipe(cartData()));
    const currentCartStatus = snapshot(this.store$.pipe(cartStatus()));

    const canAccess: boolean =
      isCartInErrorStateOrDoWeHaveTravelers(currentCartData, currentCartStatus, true) ||
      isAncillariesSkipped(currentCartData);

    if (!canAccess) {
      this.bookingService.setStep({ step: BOOKING_STEPS.ANCILLARIES });
    }

    return canAccess;
  }

  isReviewAndPayFlow = (route: ActivatedRouteSnapshot): boolean => {
    const requestedOrderId = route.queryParamMap.get('orderid');
    const requestedHash = route.queryParamMap.get('hash');

    const payStatus = snapshot(this.store$.pipe(paymentStatus()));

    return isPresent(requestedOrderId) && isPresent(requestedHash) && PaymentStatus.PENDING_VERIFICATION !== payStatus;
  };
}
